
import { Getter, State } from 'vuex-class';
import { Organ } from '@/store/lookups/types';
import { Recipient } from '@/store/recipients/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RecipientJourney } from '@/store/recipientJourney/types';
import { NumericCodeValue } from '@/store/types';

@Component
export default class NewOrganLink extends Vue {
  @State(state => state.recipients.selectedRecipient) recipient!: Recipient;

  @Getter('checkAllowed', { namespace: 'users' }) private checkAllowed!: (url: string, method?: string) => boolean;
  @Getter('organOptions', { namespace: 'lookups' }) organOptions!: (type?: string) => NumericCodeValue[];
  @Getter('nonExpiredOrganOptions', { namespace: 'lookups' }) nonExpiredOrganOptions!: (type?: string) => NumericCodeValue[];

  @Prop({ default: false }) button!: boolean;
  @Prop({ default: false }) navlink!: boolean;

  get showAddOrgan(): boolean {
    return this.checkAllowed('/recipients/:recipient_id/journeys', 'POST');
  }

  /**
   * Gets a string representation of the Recipient Client ID to use for routing
   * 
   * @returns {string}
   */
  get recipientId(): string {
    if (!this.recipient || !this.recipient.client_id) {
      return '';
    }
    return this.recipient.client_id.toString();
  }

  /**
   * Returns an array of options for Add new required organ
   * 
   * @returns {Organ[]} organ options
   */
  get addOrganOptions(): NumericCodeValue[] {
    // Build options list for organs with non-expired entry in the organ lookup
    return this.nonExpiredOrganOptions('single');
  }
}
